// extracted by mini-css-extract-plugin
export default {"progressContainer":"ChallengeProgressBar_progressContainer__AU8GG","questionLabel":"ChallengeProgressBar_questionLabel__T+xze"};